export var AdminCashLogType;
(function (AdminCashLogType) {
    AdminCashLogType["DEPOSIT"] = "deposit";
    AdminCashLogType["WITHDRAW"] = "withdraw";
    AdminCashLogType["FEEDBACK"] = "feedback";
    AdminCashLogType["ACTIVITY"] = "activity";
    AdminCashLogType["TRANSFER_IMPORT"] = "transfer_import";
    AdminCashLogType["TRANSFER_EXPORT"] = "transfer_export";
    AdminCashLogType["AGENT_TRANSFER"] = "agent_transfer";
    AdminCashLogType["OTHER"] = "other";
    AdminCashLogType["RC_ADJUSTMENT"] = "rc_adjustment";
})(AdminCashLogType || (AdminCashLogType = {}));
//# sourceMappingURL=AdminCashLogType.js.map